<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        
      >
        <div class="row"></div>
      </div>
    </section>

    <div
      class="separador text-center mt-5 py-5"
     
    >
      <p class="fXG amarillo">Buscar Email</p>
      <p class="" v-if="user != null">
        Usuario: <span class="amarillo">{{ user.nombre }}</span>
      </p>
    </div>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

      <div class="row" v-if="this.registro == null">
        <div class="col-md-6 offset-md-3">
          <form @submit="signup($event)" class="py-5 r15  mr-lg-5">
            <div class="col-12 text-left pb-4 fG">
              <span class="">Ingresa el email a buscar</span>
            </div>
            <div class="col-12">
              <div class="row pb-4">
                <div class="col-lg-12 pb-0">
                  <!-- <div class=" fG">Nombre</div> -->
                  <input
                    v-model.trim="signupForm.email"
                    type="email"
                    placeholder="Email*"
                    required
                  />
                </div>
                
              
              <div class="row pb-5">
                <div class="col-12 text-center">
                  <button
                    type="submit"
                    class="
                      pointer
                      d-flex
                      align-items-center
                      justify-content-center
                      btnaction
                      fG
                      ml-auto
                      mr-auto
                    "
                  >
                    ENVIAR
                  </button>
                </div>
              </div>


            </div></div>


            
          </form>
        </div>
      </div>

      <div class="row bgblanco" v-if="registro != null">
        <div class="col-md-6 offset-md-3 card round bg-white my-5 pt-4 pb-55">
          <p class="negro bold fG text-center">
            <span v-if="registro.nombre_1 != ''">{{ registro.nombre_1 }} </span>
            <span v-if="registro.nombre_2 != ''">{{ registro.nombre_2 }} </span>
            <span v-if="registro.apellido_paterno != ''"
              >{{ registro.apellido_paterno }}
            </span>
            <span v-if="registro.apellido_materno != ''"
              >{{ registro.apellido_materno }}
            </span>
          </p>
          <p class="negro bold fG text-center">
            {{ registro.email }}
          </p>
          <hr class="mb-4" />

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Tipo de Acceso</div>
            <div class="col-5 text-right">
              {{ registro.tipo }}
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Torneo</div>
            <div class="col-5 text-right">
              {{ registro.torneo }}
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row" v-if="registro.torneo == 'SI'">
            <div class="col-5 offset-1">Handicap</div>
            <div class="col-5 text-right">
              {{ registro.handicap }}
            </div>
          </div>

          <hr class="mb-4" v-if="registro.torneo == 'SI'"/>

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Clínica</div>
            <div class="col-5 text-right">
              {{ registro.clinica }}
              <span v-if="registro.clinica == 'SI'"
                >- {{ registro.horario_clinica }}</span
              >
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Comida</div>
            <div class="col-5 text-right">
              {{ registro.comida }}
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Empresa</div>
            <div class="col-5 text-right">
              {{ registro.empresa }}
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row">
            <div class="col-5 offset-1">Puesto</div>
            <div class="col-5 text-right">
              {{ registro.puesto }}
            </div>
          </div>
          <hr class="mb-4" />
        </div>
      </div>


      <div
        class="row bgblanco"
        v-if="registro != null  && registro.comida == 'SI' && registro.tipo == 'PATROCINADOR'"
      >
        <div class="col-md-6 offset-md-3 card round bg-white mb-5 pt-4 pb-5">
          <p class="negro bold fG text-center">GIVEAWAYS</p>
          <hr class="mb-4" />

          <div class="pb-3 negro row text-center">
            <div class="col-4">Pulsera</div>
            <div class="col-4">


              <span v-if="registro.comida == 'SI' && registro.tipo == 'PATROCINADOR'">Blanco</span>
              
              
              
             
            </div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.pulsera" />
              </label>
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row text-center">
            <div class="col-4">Número de Pulsera</div>
            <div class="col-4"></div>
            <div class="col-4">
              <label class="w-100">
                <input
                  class="text-center w50"
                  type="text"
                  v-model="formAsistencia.no_pulsera"
                  required
                />
              </label>
            </div>
          </div>
          <hr class="mb-4" />

          

          <div class="pb-3 negro row text-center" v-if="registro.asistira_al_evento == 'STAND'">
            <div class="col-4">Box Lunch</div>
            <div class="col-4">&nbsp;</div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.box_lunch" />
              </label>
            </div>
          </div>
          <hr class="mb-4" v-if="registro.asistira_al_evento == 'STAND'" />


        </div>


        <div class="col-12">
          <div class="row pb-5">
            <div class="col-12 text-center">
              <a @click="registrarAsistencia($event)" class="btnaction pointer"
                >Registrar Asistencia</a
              >
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row py-5">
            <div class="col-12 text-center">
              <a @click="escanearNuevo($event)" class="btnaction pointer"
                >Buscar nuevo código</a
              >
            </div>
          </div>
        </div>
      </div>

      <div
        class="row bgblanco"
        v-else-if="registro != null && registro.asistio == 0"
      >
        <div class="col-md-6 offset-md-3 card round bg-white mb-5 pt-4 pb-5">
          <p class="negro bold fG text-center">GIVEAWAYS</p>
          <hr class="mb-4" />

          <div class="pb-3 negro row text-center">
            <div class="col-4">Pulsera</div>
            <div class="col-4">
              <span v-if="registro.torneo == 'SI' && registro.tipo != 'PATROCINADOR'">Negro</span>
              <span v-else-if="registro.torneo == 'SI' && registro.tipo == 'PATROCINADOR'">Verde</span>

              <span v-else-if="registro.clinica == 'SI' && registro.tipo != 'PATROCINADOR'">Plata</span>
              <span v-else-if="registro.clinica == 'SI' && registro.tipo == 'PATROCINADOR'">Amarillo</span>

              <span v-else-if="registro.comida == 'SI' && registro.tipo == 'PATROCINADOR'">Blanco</span>
                  <span v-else-if="registro.tipo == 'PATROCINADOR' && registro.asistira_al_evento == 'SI'" >Rosa</span>
                  <span v-else-if="registro.tipo == 'PATROCINADOR' && registro.asistira_al_evento == 'STAND'" >Rosa</span>
                  <span v-else-if="registro.comida == 'SI' && registro.asistira_al_evento != 'STAND'">Blanco</span>
          
             
            </div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.pulsera" />
              </label>
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row text-center">
            <div class="col-4">Número de Pulsera</div>
            <div class="col-4"></div>
            <div class="col-4">
              <label class="w-100">
                <input
                  class="text-center w50"
                  type="text"
                  v-model="formAsistencia.no_pulsera"
                  required
                />
              </label>
            </div>
          </div>
          <hr class="mb-4" />

          <div class="pb-3 negro row text-center" v-if="registro.torneo == 'SI'">
            <div class="col-4">Kit Jugador</div>
            <div class="col-4"></div>
            <div class="col-4">
              <label class="w-100">
                <input
                  type="checkbox"
                  v-model="formAsistencia.kit_bienvenida"
                />
              </label>
            </div>
          </div>
          <hr class="mb-4"  v-if="registro.torneo == 'SI'" />

          <!-- <div class="pb-3 negro row text-center" v-if="registro.tipo == 'CLIENTE' || registro.tipo == 'PATROCINADOR'" >
            <div class="col-4">Regalo General</div>
            <div class="col-4"></div>
            <div class="col-4">
              <label class="w-100">
                <input
                  type="checkbox"
                  v-model="formAsistencia.regalo_bienvenida"
                />
              </label>
            </div>
          </div>
          <hr class="mb-4"  v-if="registro.tipo == 'CLIENTE' || registro.tipo == 'PATROCINADOR'"/>

          <div class="pb-3 negro row text-center" v-if="registro.tipo == 'CLIENTE' || registro.tipo == 'PATROCINADOR'">
            <div class="col-4">Número de Regalo General</div>
            <div class="col-4"></div>
            <div class="col-4">
              <label class="w-100">
                <input
                  class="text-center w50"
                  type="text"
                  v-model="formAsistencia.no_regalo_bienvenida"
                  required
                />
              </label>
            </div>
          </div>
          <hr class="mb-4"  v-if="registro.tipo == 'CLIENTE' || registro.tipo == 'PATROCINADOR'"/> -->

          <!-- <div class="pb-3 negro row text-center">
            <div class="col-4">Cubrebocas</div>
            <div class="col-4">
              {{ registro.talla_cubrebocas }}
            </div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.cubrebocas" />
              </label>
            </div>
          </div>
          <hr class="mb-4" /> -->

          <div
            class="pb-3 negro row text-center"
            v-if="registro.torneo == 'SI'"
          >
            <div class="col-4">Talla zapatos</div>
            <div class="col-4">
              
              <select v-model="registro.talla_zapatos" class="text-center" @change="changeStatusZapatos($event)" required>
                  <option value="">TALLA DE ZAPATOS*</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                </select>
            </div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.zapatos" />
              </label>
            </div>
          </div>
          <hr class="mb-4" v-if="registro.torneo == 'SI'" />

          <div
            class="pb-3 negro row text-center"
            v-if="registro.clinica == 'SI'"
          >
            <div class="col-4">Guantes</div>
            <div class="col-4">
              {{ registro.talla_guantes }}
            </div>
            <div class="col-4">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.guantes" />
              </label>
            </div>
          </div>
          <hr class="mb-4" v-if="registro.clinica == 'SI'" />

          <div class="pb-3 negro row text-center" v-if="registro.asistira_al_evento == 'STAND'">
            <div class="col-6">Box Lunch</div>
            
            <div class="col-6">
              <label class="w-100">
                <input type="checkbox" v-model="formAsistencia.box_lunch" />
              </label>
            </div>
          </div>
          <hr class="mb-4" v-if="registro.asistira_al_evento == 'STAND'" />


        </div>


        <div class="col-12">
          <div class="row pb-5">
            <div class="col-12 text-center">
              <a @click="registrarAsistencia($event)" class="btnaction pointer"
                >Registrar Asistencia</a
              >
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row py-5">
            <div class="col-12 text-center">
              <a @click="escanearNuevo($event)" class="btnaction pointer"
                >Buscar nuevo email</a
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="row bgblanco"
        v-else-if="registro != null && registro.asistio == 1"
      >
        <div class="col-md-6 offset-md-3 card round bg-white mb-5 pt-4 pb-5">
          <p class="negro bold fG text-center">GIVEAWAYS</p>
          <p class="negro text-center">
            (Asistencia registrada {{ registro.fecha_asistio }})
          </p>
          <hr class="mb-4" />

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-3 offset-1">Pulsera</div>
                <div class="col-3 text-center">
                  <span v-if="registro.torneo == 'SI' && registro.tipo != 'PATROCINADOR'">Negro</span>
                  <span v-else-if="registro.torneo == 'SI' && registro.tipo == 'PATROCINADOR'">Verde</span>

                  <span v-else-if="registro.clinica == 'SI' && registro.tipo != 'PATROCINADOR'">Plata</span>
                  <span v-else-if="registro.clinica == 'SI' && registro.tipo == 'PATROCINADOR'">Amarillo</span>

                  <span v-else-if="registro.comida == 'SI' && registro.tipo == 'PATROCINADOR'">Blanco</span>
                  <span v-else-if="registro.tipo == 'PATROCINADOR' && registro.asistira_al_evento == 'SI'" >Rosa</span>
                  <span v-else-if="registro.tipo == 'PATROCINADOR' && registro.asistira_al_evento == 'STAND'" >Rosa</span>
                  <span v-else-if="registro.comida == 'SI' && registro.asistira_al_evento != 'STAND'">Blanco</span>
                </div>
                <div class="col-4 text-right">
                  <span v-if="registro.pulsera == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Número de Pulsera</div>
                
                <div class="col-5 text-right">
                  <span>{{registro.no_pulsera}}</span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Kit Jugador</div>
                <div class="col-5 text-right">
                  <span v-if="registro.kit_bienvenida == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Regalo General</div>
                <div class="col-5 text-right">
                  <span v-if="registro.regalo_bienvenida == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Número de Regalo General</div>
                
                <div class="col-5 text-right">
                  <span>{{registro.no_regalo_bienvenida}}</span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div> -->

          <!-- <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Cubrebocas</div>
                <div class="col-5 text-right">
                  <span v-if="registro.cubrebocas == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div> -->

          <!-- <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Chamarra</div>
                <div class="col-5 text-right">
                  <span v-if="registro.top == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div> -->

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-3 offset-1">Guantes</div>
                <div class="col-4 text-center">
                  {{ registro.talla_guantes }}
                </div>
                <div class="col-3 text-right">
                  <span v-if="registro.guantes == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-4 offset-1">Talla Zapatos</div>
                <div class="col-2">{{ registro.talla_zapatos }}</div>
                <div class="col-4 text-right">
                  <span v-if="registro.zapatos == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>


          <div class="row">
            <div class="col-12">
              <div class="pb-3 negro row">
                <div class="col-5 offset-1">Box Lunch</div>
                <div class="col-5 text-right">
                  <span v-if="registro.box_lunch == 1">
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/check.png"
                      alt="Check"
                    />
                  </span>
                  <span v-else>
                    <img
                      width="25"
                      src="../assets/imgs/copaprosa/home/close.png"
                      alt="Close"
                    />
                  </span>
                </div>
              </div>
              <hr class="mb-4" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="row py-5">
                <div class="col-12 text-center">
                  <a @click="escanearNuevo($event)" class="btnaction pointer"
                    >Buscar nuevo email</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNavLector";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);



export default {
  components: {
    Footer,
    SiteNav,

    // Glyphicons,
  },
  data() {
    return {
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        email: "",
      },
      formAsistencia: {
        pulsera: false,
        no_pulsera: "",
        kit_bienvenida: false,
        regalo_bienvenida: false,
        no_regalo_bienvenida: "",
        zapatos: false,
        sudadera: false,
        guantes: false,
        cubrebocas: false,
        box_lunch: false
      },

      columnsRegistros: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
        "torneo",
        "handicap",
        "talla_tops",
        "clinica",
        "talla_guantes",
        "talla_cubrebocas",
        "terminos",
      ],
      columnsInvitados: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registro: null,
      invitados: [],
      user: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_copaprosa2021_lector"));

    this.signupForm.email = this.$route.params.email;

    if(this.signupForm.email != null && this.signupForm.email != undefined){
      this.buscaEmail();
    }
  },
  methods: {
    async changeStatusZapatos(status) {
      // console.log({ changeStatusCodigo: codigo });
      // console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: this.registro.codigo,
        status: this.registro.talla_zapatos,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusZapatos.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e=null) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.buscaEmail();
    },
    async buscaEmail() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroXEmail.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            this.$store.dispatch("showLoader", false);
            console.log("res registro x email");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos[0];
              console.log({registro: this.registro})
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        
        email: "",
        
      };
      this.centroForm = {
        clasificacion: "",
        no_cliente: "",
        nombre_completo: "",
        cedis: "",
        objetivo_semanal: "",
      };
    },
    async onDecode(decodedString) {
      console.log(decodedString);

      this.getRegistro(decodedString);
    },
    getRegistro(decodedString) {
      console.log("get registro");

      const https = require("https");
      var qData = {
        codigos: decodedString,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos[0];
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    registrarAsistencia(e) {
      console.log("registra asistencia");



      // if(this.formAsistencia.no_pulsera == ''){
      //   swal.fire("Oops", "Completa todos los campos antes de continuar...", "warning");
      //   return
      // }

      // if(isNaN(this.formAsistencia.no_pulsera)){
      //   swal.fire("Oops", "El campo No. de pulsera debe ser un número...", "warning");
      //   return
      // }
      
      // if(this.formAsistencia.no_regalo_bienvenida != '' && isNaN(this.formAsistencia.no_regalo_bienvenida)){
      //   swal.fire("Oops", "El campo No. de Regalo de Bienvenida debe ser un número...", "warning");
      //   return
      // }



      this.$store.dispatch("showLoader", true);
      const https = require("https");
      var qData = this.formAsistencia;
      qData.codigo = this.registro.codigo;
      qData.email = this.registro.email;
      qData.id_operador_asistio = this.user.id;

      

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registrarAsistencia.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              swal
                .fire({
                  title: "Bien",
                  html: res.msg,
                  icon: "success",
                  confirmButtonText: "Ok",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  window.location.reload();
                });
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    escanearNuevo(e) {
      this.formAsistencia.pulsera = false;
      this.formAsistencia.kit_bienvenida = false;
      this.formAsistencia.zapatos = false;
      this.formAsistencia.sudadera = false;
      this.formAsistencia.guantes = false;
      this.formAsistencia.cubrebocas = false;
      this.formAsistencia.no_pulsera = "";
      this.formAsistencia.no_regalo_bienvenida = "";
      this.formAsistencia.box_lunch = false;
      this.registro = null;
      window.location.reload();
    },
  },
};
</script>

